import type { LiveTruck } from '@chukua/common';
import { truckMapStatus, type TruckMapStatus } from './truck-map-status';

export interface TruckFeatureProperties {
  truckId: string;
  registration: string;
  status: TruckMapStatus;
  /** Degrees clockwise from north; 0 when the fix has none, which the map draws as a dot with no pointer. */
  heading: number;
  hasHeading: boolean;
}

export interface TruckFeature {
  type: 'Feature';
  geometry: { type: 'Point'; coordinates: [number, number] };
  properties: TruckFeatureProperties;
}

export interface TruckFeatureCollection {
  type: 'FeatureCollection';
  features: TruckFeature[];
}

/** The map's one source: a point per truck carrying what its layers paint by. Rebuilt on every tick, since a status changes with the clock alone. */
export function liveTruckFeatures(trucks: LiveTruck[], now: Date): TruckFeatureCollection {
  return {
    type: 'FeatureCollection',
    features: trucks.map((truck) => ({
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [truck.fix.lng, truck.fix.lat] },
      properties: {
        truckId: truck.truckId,
        registration: truck.registration,
        status: truckMapStatus(truck.fix, now),
        heading: truck.fix.headingDeg ?? 0,
        hasHeading: truck.fix.headingDeg !== null,
      },
    })),
  };
}
